import PlannerMonth, { PlannerMonthProps } from '@oberoninternal/travelbase-ds/components/calendar/PlannerMonth';
import styled from 'styled-components';

const ActivityPlannerMonth = ({ ...props }: PlannerMonthProps) => <StyledPlannerMonth {...props} />;

const StyledPlannerMonth = styled(PlannerMonth)`
    @media screen and (min-width: ${({ theme }) => theme.mediaQueries.s}) {
        width: 100%;
    }

    @media screen and (min-width: ${({ theme }) => theme.mediaQueries.xl}) {
        width: 100%;
    }
`;

export default ActivityPlannerMonth;
